





































































































































import { Vue, Component } from "vue-property-decorator";
import { SweetAlertOptions, SweetAlertResult } from "sweetalert2";
import { version, description } from "vue-simple-alert/package.json";
import GithubRibbon from "@/components/GithubRibbon.vue";

@Component({
  components: { GithubRibbon }
})
export default class App extends Vue {
  readonly v: string = version;
  readonly des: string = description;

  alertExample0() {
    window.alert("This is normal alert.");
  }
  alertExample1() {
    this.$alert("This is simple but cool alert.").then(() =>
      console.log("Closed")
    );
  }
  alertExample2() {
    this.$alert("This is simple but cool alert with title.", "Example").then(
      () => console.log("Closed")
    );
  }
  alertExample3() {
    this.$alert(
      "This is simple but cool alert with icon.",
      "Success",
      "success"
    ).then(() => console.log("Closed"));
  }
  alertExample4() {
    this.$alert(
      "This is simple but cool alert with icon.",
      "Warning",
      "warning"
    ).then(() => console.log("Closed"));
  }

  confirmExample0() {
    window.confirm("This is normal confirm.");
  }
  confirmExample1() {
    this.$confirm("This is cool confirm.", "Confirm");
  }
  confirmExample2() {
    this.$confirm(
      "This is cool confirm with question icon.",
      "Question",
      "question"
    )
      .then((r: boolean) => {
        console.log(r);
      })
      .catch(() => {
        console.log("OK not selected.");
      });
  }
  confirmExample3() {
    this.$confirm("This is cool confirm with error icon.", "Error", "error")
      .then((r: boolean) => {
        console.log(r);
        this.$alert("OK selected.");
      })
      .catch(() => {
        console.log("OK not selected.");
      });
  }

  promptExample0() {
    window.alert(window.prompt("Input your name", "John Doe"));
  }
  promptExample1() {
    this.$prompt("Input your name", "John Doe").then((r: string) => {
      if (r) this.$alert(r, "Your name is:", "success");
    });
  }
  promptExample2() {
    this.$prompt("Input your name", "John Doe", "Example", "question")
      .then((r: string) => {
        this.$alert(r, "Your name is:", "success");
      })
      .catch(() => console.log("canceled"));
  }
  promptExample3() {
    this.$prompt(
      "Input your email",
      "someone@example.com",
      "Example",
      "question",
      { input: "email" }
    )
      .then((r: string) => {
        this.$alert(r, "Your email is:", "success");
      })
      .catch(() => console.log("canceled"));
  }

  advancedExample1() {
    const options: SweetAlertOptions = {
      title: "<strong>Advanced</strong> &nbsp; example",
      text: "This dialog will be closed after 3 seconds.",
      footer: "<a href=''>Check out sweetalert2 documentation.</a>",
      type: "success",
      showCancelButton: true,
      confirmButtonText: "<i class='fa fa-thumbs-up'></i> Great!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      timer: 3000,
      width: 500,
      animation: false,
      customClass: {
        popup: "animated tada"
      },
      padding: "3em",
      background: "#fff",
      backdrop: `
        rgba(0,0,123,0.4)
        center left
        no-repeat
      `
    };

    this.$fire(options).then((r: SweetAlertResult) => {
      if (r.value) this.$alert(r.value, "Result");
    });
  }
  advancedExample2() {
    this.$alert(
      "This is advanced alert with custom button text",
      "Example",
      "success",
      {
        confirmButtonText: "Got it!"
      }
    );
  }
  advancedExample3() {
    this.$confirm("This is dialog has reversed buttons.", "Error", "error", {
      reverseButtons: true
    })
      .then((r: boolean) => {
        console.log(r);
      })
      .catch(() => {
        console.log("OK not selected.");
      });
  }
}
